import React from 'react'
import { i18n } from 'lib/i18n'
import Image from 'next/image'

import Heading from 'components/Heading/Heading'
import useMarketId from 'hooks/useMarketId'

import aftonbladet from './aftonbladet-badge.png'
import theathletic from './athletic-badge.png'
import bbc from './bbc-badge.webp'
import breakit from './breakit-badge.jpg'
import businessInsider from './businessinsider-badge.png'
import cbc from './cbc-badge.png'
import cityam from './city-am-badge.jpg'
import dagensmedia from './dagens-media-badge.svg'
import dailymirror from './daily-mirror-badge.png'
import dailystar from './daily-star-badge.webp'
import didigital from './di-badge.jpg'
import expressen from './expressen-badge.jpg'
import forbes from './forbes-badge.png'
import friends from './friends-badge.png'
import theglobeandmail from './globe-and-mail-badge.png'
import metronews from './metro-badge.jpg'
import qx from './qx-badge.png'
import resume from './resume-badge.jpg'
import scotsman from './scotsman-badge.png'
import skynews from './sky-news-badge.png'
import thesun from './the-sun-badge.jpg'
import wired from './wired-badge.png'

import styles from './PressCoverage.module.css'

const PressCoverage = ({
  title = i18n.t('PressCoverage.headline', 'Press'),
  noTitle = false,
}) => {
  const marketId = useMarketId()
  const articles = [
    {
      image: cbc,
      imageAlt: 'CBC',
      pressName: 'CBC',
      title:
        "CFL Players' Association partners with personalized video platform to bring players, fans closer together",
      href: 'https://www.cbc.ca/sports/football/cfl/cfl-cflpa-partnerships-memmo-fan-connection-1.5910851',
      markets: ['ca'],
      date: '11-02-2021',
    },
    {
      image: bbc,
      imageAlt: 'BBC',
      pressName: 'BBC',
      title: 'Plasma, Cheap Phones and Celebs - BBC Click',
      href: 'https://www.youtube.com/watch?t=1256&v=fiPFUY3FN5g&feature=youtu.be',
      date: '22-12-2020',
    },
    {
      image: forbes,
      imageAlt: 'Forbes',
      pressName: 'Forbes',
      title:
        "Following Cameo's Success, Swedish Challenger Memmo Starts Conquering Europe With Personalized Celebrity Videos",
      href: 'https://www.forbes.com/sites/igorbosilkovski/2020/04/17/following-cameos-success-swedish-challenger-memmo-starts-conquering-europe-with-personalized-celebrity-videos/',
      date: '17-04-2020',
    },
    {
      image: wired,
      imageAlt: 'Wired',
      pressName: 'Wired',
      title: 'On the Capitalist Internet, Even Celebs Join the Gig Economy',
      href: 'https://www.wired.com/story/on-the-capitalist-internet-even-celebs-join-the-gig-economy/',
      date: '04-02-2021',
    },
    {
      image: theglobeandmail,
      imageAlt: 'The Globe and Mail',
      pressName: 'The Globe and Mail',
      title: "Outsourcing my Mother's Day gift to John Gibbons paid off",
      href: 'https://www.theglobeandmail.com/sports/article-outsourcing-my-mothers-day-gift-to-john-gibbons-paid-off/',
      markets: ['ca'],
      date: '07-05-2021',
    },
    {
      image: businessInsider,
      imageAlt: 'Business Insider',
      pressName: 'Business Insider',
      title:
        "Europe's answer to Cameo is a 9 month old startup that has blown up during the coronavirus pandemic with a 128% increase in usage and $2 million in new funding",
      href: 'https://www.businessinsider.com/memmo-european-tech-startup-is-swedens-answer-to-cameo-2020-5',
      markets: ['ca', 'global', 'gb'],
      date: '18-05-2020',
    },

    {
      image: skynews,
      imageAlt: 'Skynews',
      pressName: 'Skynews',
      title:
        'Why more celebrities are selling video messages during pandemic - and the bizarre requests they receive',
      href: 'https://news.sky.com/story/why-more-celebrities-are-selling-video-messages-during-pandemic-from-marriage-proposals-to-break-up-requests-12261547',
      markets: ['ca', 'global', 'gb'],
      date: '05-04-2021',
    },
    {
      image: dailystar,
      imageAlt: 'Daily Star',
      pressName: 'Daily Star',
      title:
        "You can now buy a personalised message from a celebrity of your choice this Father's Day",
      href: 'https://www.dailystar.co.uk/real-life/you-can-now-buy-personalised-24296163',
      markets: ['global'],
      date: '13-06-2021',
    },
    {
      image: theathletic,
      imageAlt: 'The Athletic',
      pressName: 'The Athletic',
      title: 'A holiday gift from Borje Salming, Ray Ferraro and more',
      href: 'https://theathletic.com/2276327/2020/12/22/a-holiday-gift-from-borje-salming-ray-ferraro-and-more-for-a-fee/',
      markets: ['ca', 'global'],
      date: '22-12-2020',
    },

    {
      image: dailymirror,
      imageAlt: 'Daily Mirror',
      pressName: 'Daily Mirror',
      title:
        'You can pay UK celebrities to give you personalised shout-outs - and some only charge £5',
      href: 'https://www.mirror.co.uk/tech/you-can-pay-uk-celebrities-22993295',
      markets: ['gb', 'au', 'ca', 'dk', 'fi', 'fr', 'de', 'no'],
      date: '12-11-2020',
    },
    {
      image: metronews,
      imageAlt: 'Metro',
      pressName: 'Metro',
      title:
        'The Office star Ewen MacIntosh mourns loss of Christmas parties that helped make show cult viewing',
      href: 'https://metro.co.uk/2020/12/18/the-office-star-mourns-loss-of-christmas-parties-spoofed-by-show-13769753/',
      markets: ['gb', 'au', 'ca', 'dk', 'fi', 'fr', 'de', 'no'],
      date: '18-12-2020',
    },
    {
      image: scotsman,
      imageAlt: 'The Scotsman',
      pressName: 'The Scotsman',
      title: 'Here are 13 Scottish celebrities you can find on Cameo and Memmo',
      href: 'https://www.scotsman.com/news/people/here-are-13-scottish-celebrities-you-can-find-on-cameo-and-memmo-3141038',
      markets: ['gb', 'au', 'ca', 'dk', 'fi', 'fr', 'de', 'no'],
      date: '19-02-2021',
    },
    {
      image: cityam,
      imageAlt: 'CITY A.M.',
      pressName: 'CITY A.M.',
      title:
        'Pride and paradox: How to celebrate business success in the midst of a pandemic',
      href: 'https://www.cityam.com/pride-and-paradox-how-to-celebrate-business-success-in-the-midst-of-a-pandemic/',
      markets: ['gb', 'au', 'ca', 'dk', 'fi', 'fr', 'de', 'no'],
      date: '02-12-2020',
    },
    {
      image: thesun,
      imageAlt: 'The Sun',
      pressName: 'The Sun',
      title:
        'IF YA WANT MY BODY DOUBLE! Sir Rod Stewart paid £25 for a birthday surprise for his 26-year-old son Liam — a Rod Stewart tribute act',
      href: 'https://www.thesun.co.uk/tvandshowbiz/14112811/rod-stewart-tribute-act-birthday-surprise-son-liam/',
      markets: ['gb', 'global'],
      date: '20-02-2021',
    },

    {
      image: breakit,
      imageAlt: 'Breakit',
      pressName: 'Breakit',
      title: 'Så gick Memmo från noll till hajp i hela Sverige - på 90 dagar',
      href: 'https://www.breakit.se/artikel/23710/sa-gick-memmo-fran-noll-till-hajp-i-hela-sverige-pa-90-dagar',
      markets: ['se'],
      date: '19-02-2020',
    },
    {
      image: aftonbladet,
      imageAlt: 'Aftonbladet',
      pressName: 'Aftonbladet',
      title: 'Kändisarna samlar in pengar - för att bekämpa coronakrisen',
      href: 'https://www.aftonbladet.se/nojesbladet/a/lA5GKL/kandisarna-samlar-in-pengar--for-att-bekampa-coronakrisen',
      markets: ['se'],
      date: '20-03-2020',
    },
    {
      image: resume,
      imageAlt: 'Resume',
      pressName: 'Resume',
      title: 'De säljer videohälsningar från kändisar - för kommersiellt bruk',
      href: 'https://www.resume.se/marknadsforing/kampanj/de-saljer-videohalsningar-fran-kandisar-for-kommersiellt-bruk/',
      markets: ['se'],
      date: '05-10-2020',
    },
    {
      image: dagensmedia,
      imageAlt: 'Dagens media',
      pressName: 'Dagens media',
      title: "Memmos grundare: ”Vi har i princip bara levt på 'word-of-mouth'”",
      href: 'https://www.dagensmedia.se/nyheter/under-15/memmos-grundare-vi-har-i-princip-bara-levt-pa-word-of-mouth/',
      markets: ['se'],
      date: '25-05-2020',
    },
    {
      image: qx,
      imageAlt: 'QX',
      pressName: 'QX',
      title: 'Kändisar och HBTQ-profiler stöttar Regnbågsfonden',
      href: 'https://www.qx.se/noje/kandis-noje/198748/kandisar-och-hbtq-profiler-stottar-regnbagsfonden/',
      markets: ['se'],
      date: '09-07-2020',
    },

    {
      image: didigital,
      imageAlt: 'DI Digital',
      pressName: 'DI Digital',
      title:
        'Memmos succéstart: Därför vill fler ha hälsning från sina idoler under coronakrisen',
      href: 'https://digital.di.se/artikel/memmos-succestart-darfor-vill-fler-ha-halsning-fran-sina-idoler-under-coronakrisen',
      markets: ['se'],
      date: '25-03-2020',
    },
    {
      image: expressen,
      imageAlt: 'Expressen',
      pressName: 'Expressen',
      title:
        'Ola Rapace, Anna Anka och Victoria Silvstedt - bara några av alla bakom Mustaschkampen',
      href: 'https://www.expressen.se/sport/foreningsliv/brand-studio/folkspel/ola-rapace-anna-anka-och-victoria-silvstedt-bara-nagra-av-alla-bakom-mustaschkampen/',
      markets: ['se'],
      date: '06-11-2020',
    },
    {
      image: friends,
      imageAlt: 'Friends',
      pressName: 'Friends',
      title: 'Memmo och kända profiler stöttar Friends',
      href: 'https://friends.se/memmo-och-kanda-profiler-stottar-friends/',
      markets: ['se'],
      date: '30-09-2020',
    },
  ]

  return (
    <section className={styles.wrapper}>
      {!noTitle && (
        <Heading level="h3">
          <h3>{title}</h3>
        </Heading>
      )}

      {articles.map((article) => {
        if (
          Array.isArray(article.markets) &&
          !article.markets.includes(marketId)
        ) {
          return null
        }
        return (
          <a
            key={article.href}
            href={article.href}
            target="_blank"
            rel="noopener noreferrer nofollow"
            className={styles.item}
          >
            <div className={styles.image}>
              <Image
                src={article.image}
                alt={article.imageAlt}
                width={100}
                height={100}
                unoptimized
              />
            </div>
            <div className={styles.content}>
              <p className={styles.pressName}>{article.pressName}</p>
              <Heading level="h5">
                <h3 className={styles.title}>{article.title}</h3>
              </Heading>
              <p className={styles.date}>{article?.date}</p>
            </div>
          </a>
        )
      })}
    </section>
  )
}

export default PressCoverage
